module.exports = __webpack_public_path__ + "static/img/contract_step_3.edc30da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contract_step_3.png
// module id = 72ck
// module chunks = 1